/* eslint-disable no-undef */
import React, { useState } from 'react';
import { BlockButton, TextInput, Loading, NavBar, Footer, PersonIcon } from '../PageElements.js';
import { validateEmail } from '../../utils/ValidateInput.js';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { LOGIN } from '../../Graphql/User.js';
import Session from '../../utils/Session.js';
import jwt_decode from 'jwt-decode';
import Redirect from '../../utils/Redirect.js';
import { APIResponse } from '../../utils/Helpers.js';
import { BsFileEarmarkLock, BsHouseLockFill } from 'react-icons/bs/index.js';

const Login = () => {

    React.useEffect(() => {
        Session.showAlert();
    }, []);
    const [userLogin, { loading }] = useMutation(LOGIN, {
        fetchPolicy: 'no-cache',
        onCompleted: data => {

            try {
                const decoded = jwt_decode(data.login.accessToken);
                const isExpired = decoded.exp <= Math.floor(Date.now() / 1000);
                if (!isExpired && decoded.id) {
                    //Session.clear()
                    Session.setSecureValue('x-access-token', data.login.accessToken);
                    Session.setSecureValue('x-refresh-token', data.login.refreshToken);
                    Redirect('/dashboard');
                } else {
                    Session.setSecureValue('x-access-token', '');
                    Session.setSecureValue('x-refresh-token', '');
                    Session.setCookie('x-access-token', '');
                    Session.setCookie('x-refresh-token', '');
                    Session.clear();
                    Session.alert('Invalid login credentials!');
                    Session.showAlert();
                }
            } catch (err) {
                // err
                Session.clear();
                Session.alert('Invalid login credentials...');
                Session.showAlert();
            }
        },
        onError: error => {
            Session.clear();
            Session.alert('Unable to login.');

            APIResponse(error);
            Session.showAlert();
        }
    });


    const [inputs, setInputs] = useState({});
    const [showPassword, setShowPassword] = useState(false);


    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({ ...values, [name]: value }));
    };

    const doLogin = () => {
        Session.clear();
        validateEmail(inputs.email);
        if (!inputs.password) Session.alert('Password must not be empty!');
        if (Session.hasAlert()) {
            Session.showAlert();
            return;
        }
        userLogin({
            variables: {
                email: inputs.email,
                password: inputs.password
            }
        });
    };

    if (loading) return <Loading _fullPage={true} />;


    return (
        <div className="">

            <NavBar />
            <div className='w3-animate-right container'>
                <div className='row'>
                    <div className='col-md-6'>
                        <h3>Login</h3>
                        <p className="mt-3">Log in with your syllabux account.</p>

                        <TextInput _parentClass='' _label="Enter Email" _type="email" _value={inputs.email} _name="email" _onChange={handleChange} />
                        <div className='position-relative'>
                            <TextInput _parentClass='' _label="Enter Password" _type={showPassword ? 'text' : 'password'} _value={inputs.password} _name="password" _onChange={handleChange} />
                            {showPassword ? <p className='position-absolute top-50 end-0 translate-middle-y pe-3 mb-0' onClick={() => setShowPassword(false)} style={{ zIndex: 3 }} >Hide</p> : <p className='position-absolute top-50 end-0 translate-middle-y pe-3 mb-0' onClick={() => setShowPassword(true)} style={{ zIndex: 3 }} >Show</p>}
                        </div>

                        <BlockButton _parentClass='' _name="Login" _method={doLogin} />
                        <div className='mt-5'>Forgot your password? <Link to="/forgot">Click here</Link></div>
                        <div className='mt-3'>Dont have a syllabux account? <Link to="/register">Click here</Link></div>
                        <div className='mt-3'>Need to activate your account? <Link to="/activate">Click here</Link></div>


                    </div>
                    <div className='d-none d-md-inline-block col-md-6 pt-5 text-center'>
                        <img loading='lazy' src={Session.object('LINKS')?.homepage + 'images/login.png'} style={{ maxWidth: '500px' }} className='w-100' />
                    </div>
                </div>
                <div className='mw-400p mt-5'>
                </div>
                <Footer>
                    <div className='row'>
                        <div className='col m-0 p-0'>
                            <Link to="/register" className="btn w3-btn w-100 pb-3"><PersonIcon className='ft-icon' /><br />Register</Link>
                        </div>
                        <div className='col m-0 p-0'>
                            <Link to="/activate" className="btn w3-btn w-100 pb-3"><BsFileEarmarkLock className='ft-icon' /><br />Activate</Link>
                        </div>
                        <div className='col m-0 p-0'>
                            <Link to="/forgot" className="btn w3-btn w-100 pb-3"><BsHouseLockFill className='ft-icon' /><br />Forgot Password</Link>
                        </div>
                    </div>
                </Footer>
            </div>
        </div>
    );
};

export default Login;